module.exports = new __parcel__URL__("nasa_helps_map_impact_covid19.ee326f09.png").toString();